// Encode data as Base64
function encodeBase64(data) {
  return btoa(unescape(encodeURIComponent(data)));
}

// Decode Base64 data
function decodeBase64(encodedData) {
  return decodeURIComponent(escape(atob(encodedData)));
}


// Function to get data from sessionStorage
export const getSessionStorageItem = (key) => {
  const encodedData = sessionStorage.getItem(key);
  if (encodedData) {
    return JSON.parse(decodeBase64(encodedData));
  }
  return null;
};

// Function to set data in sessionStorage
export const setSessionStorageItem = (key, data) => {
  const encodedData = encodeBase64(JSON.stringify(data));
  sessionStorage.setItem(key, encodedData);
};